import React from 'react'

const skillGroups = [
  {
    title: 'Frontend',
    skills: ['React', 'Next.js', 'JavaScript', 'TypeScript', 'HTML5', 'CSS3', 'Tailwind CSS', 'Redux.js', 'jQuery', 'Bootstrap', 'CSS', 'Front-End Development'],
  },
  {
    title: 'Backend & APIs',
    skills: ['Node.js', 'Express.js', 'PHP', 'CodeIgniter', 'REST APIs', 'GraphQL', 'Python', 'Server Side', 'Model-View-Controller (MVC)', 'Web Technologies'],
  },
  {
    title: 'Cloud & DevOps',
    skills: ['AWS', 'AWS Lambda', 'AWS CloudFormation', 'AWS IAM', 'AWS CLI', 'Amazon EC2', 'Amazon S3', 'Amazon DynamoDB', 'AWS IoT', 'Docker', 'Git', 'CI/CD', 'Version Control'],
  },
  {
    title: 'Data & Platforms',
    skills: ['PostgreSQL', 'MySQL', 'MongoDB', 'SQL', 'WordPress', 'Shopify', 'IoT', 'MQTT', 'Zoho CRM', 'Zoho Analytics BI', 'Bubble.io', 'Web3', 'E-Commerce', 'KYC Verification'],
  },
  {
    title: 'Delivery & Product',
    skills: ['Full-Stack Development', 'Software Development', 'Software Design', 'Software Infrastructure', 'Agile Methodologies', 'Sprint Planning', 'Team Management', 'Communication', 'Unit Testing', 'Linux'],
  },
]

function Skills() {
  return (
    <section className="ftco-section" id="skills-section">
      <div className="container">
        <div className="row justify-content-center pb-5">
          <div className="col-md-12 heading-section text-center ">
            <h1 className="big big-2">Skills</h1>
            <h2 className="mb-4">Core Stack</h2>
            <p>
              A practical toolkit built around full-stack delivery, cloud services, and product-focused engineering.
            </p>
          </div>
        </div>

        <div className="row">
          {skillGroups.map((group) => (
            <div className="col-md-6 mb-4" key={group.title}>
              <div
                className="p-4 h-100"
                style={{
                  background: 'linear-gradient(135deg, rgba(255,255,255,0.08), rgba(255,255,255,0.03))',
                  border: '1px solid rgba(255,255,255,0.12)',
                  borderRadius: '18px',
                  boxShadow: '0 16px 40px rgba(0,0,0,0.24)',
                  backdropFilter: 'blur(12px)',
                }}
              >
                <h3 className="mb-3 text-white">{group.title}</h3>
                <div className="d-flex flex-wrap" style={{ gap: '0.65rem' }}>
                  {group.skills.map((skill) => (
                    <span
                      key={skill}
                      className="px-3 py-2 rounded-pill"
                      style={{
                        background: 'rgba(255,255,255,0.08)',
                        border: '1px solid rgba(255,255,255,0.14)',
                        color: '#e7eefc',
                        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.06)',
                      }}
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Skills